module.exports = __webpack_public_path__ + "static/media/pillow.9eb4570b.jpg";